<template>
  <div class="auth-wrapper password-reset">
         <div v-if="!isMobile" class="auth-wrapper auth-wrapper-left"></div>

        <div class="auth-wrapper-rigth">
<div class="auth-wrapper__content">
      <div class="auth-wrapper__logo logo">
                    <figure class="figure-logo">
                        <img src="/static/logos/logo_dv7.png" alt="40%" width="80%">
                    </figure>
                </div>
      <lang-select class="set-language"/>

      <el-form
        :model="model"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="0px"
        :class="{'login-container': !isMobile, 'login-container-mobile': isMobile}"
        @submit.native.prevent
      >
        <el-form-item prop="email">
          <el-input
            type="text"
            v-model="model.email"
            @keyup.enter.native="submit"
            auto-complete="off"
            :placeholder="$t('auth.passwordReset.email')"
            ref="focus"
          ></el-input>
        </el-form-item>
        <el-form-item style="width:100%;">
          <el-button
            type="primary"
            style="width:100%;"
            @click="submit"
            :disabled="sent"
          >{{$t("auth.passwordReset.sendPasswordReset")}}</el-button>
        </el-form-item>
        <el-form-item class="text-center">
          <router-link :to="{ name: 'login' }">{{$t('auth.passwordReset.cancel')}}</router-link>
        </el-form-item>
      </el-form>
    </div>
        </div>
    
  </div>
</template>

<script>
import validators from "@/shared/form/validators";
import { mapGetters } from "vuex";
import LangSelect from '@/components/LangSelect'

export default {
  name: "app-password-reset",
  
  components: { LangSelect },

  data() {
    return {
      sent: false,
      rules: {
        email: validators.string({ label: "Email", required: true })
      },
      model: {}
    };
  },

  computed: {
    ...mapGetters({
      isMobile: "shared/isMobile"
    })
  },

  methods: {
    submit() {
      this.$refs.form.validate().then(valid => {
        if (!valid) {
          return;
        }

        this.sent = true;

        this.$store
          .dispatch("auth/sendPasswordResetEmail", this.model.email)
          .then(() => {
            this.$router.push({ name: "login" });
          })
          .catch(() => {
            this.sent = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.set-language {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size:20px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/auth/password-reset/password-reset.vue?1180c048